import { Trans } from '@lingui/react/macro';
import React from 'react';
import UDText from 'ud-ui/components/text';
import Days from './elements/days';
import Header from './elements/header';
import { DaysWeek, Divider, MainBlock } from './styles';

function DataPicker() {
  return (
    <MainBlock>
      <div style={{ paddingInline: 16 }}>
        <Header />
        <DaysWeek>
          {/* Колонки календаря узкие: подпись дня недели — ровно две буквы в любом языке (Mo, Tu…). */}
          <UDText style={{ color: 'inherit' }} type={'subhead'}>
            <Trans comment="Two-letter weekday abbreviation for a calendar column">Пн</Trans>
          </UDText>
          <UDText style={{ color: 'inherit' }} type={'subhead'}>
            <Trans comment="Two-letter weekday abbreviation for a calendar column">Вт</Trans>
          </UDText>
          <UDText style={{ color: 'inherit' }} type={'subhead'}>
            <Trans comment="Two-letter weekday abbreviation for a calendar column">Ср</Trans>
          </UDText>
          <UDText style={{ color: 'inherit' }} type={'subhead'}>
            <Trans comment="Two-letter weekday abbreviation for a calendar column">Чт</Trans>
          </UDText>
          <UDText style={{ color: 'inherit' }} type={'subhead'}>
            <Trans comment="Two-letter weekday abbreviation for a calendar column">Пт</Trans>
          </UDText>
          <UDText style={{ color: 'inherit' }} type={'subhead'}>
            <Trans comment="Two-letter weekday abbreviation for a calendar column">Сб</Trans>
          </UDText>
          <UDText style={{ color: 'inherit' }} type={'subhead'}>
            <Trans comment="Two-letter weekday abbreviation for a calendar column">Вс</Trans>
          </UDText>
        </DaysWeek>
      </div>
      <Divider />
      <div style={{ paddingInline: 16, marginTop: 8 }}>
        <Days />
      </div>
    </MainBlock>
  );
}

export default DataPicker;
